/** The board frame (unit convention §1). */
import React from 'react';

import {bump} from '../renderCount';
import {useBoardFrameModel} from './model';
import BoardFrameView from './View';

export default React.memo(function BoardFrame() {
  bump('BoardFrame');
  return <BoardFrameView {...useBoardFrameModel()} />;
});
